import Button from './button';

export default (props) => {
    const { children } = props;

    return <Button { ...props } className="button--modify" icon='create'>{ children ? children : 'Modify' }</Button>
}